import React from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { Body1, Body2, HeaderBlock, SubheaderBlock, Button, Separator, LayoutBand } from '@fs/zion-ui'
import Head, { Title } from '@fs/zion-head'
// eslint-disable-next-line import/no-named-as-default
import Link from './Link'
import NotFoundImage from './NotFoundImage'

export default function NotFound() {
  const [t] = useTranslation()

  return (
    <>
      <Title>{t('not-found.title', 'Page Not Found')}</Title>
      <Head>
        <meta name="prerender-status-code" content="404" />
      </Head>
      <LayoutBand maxWidth="sm">
        <div
          data-testid="notfound"
          css={css`
            text-align: center;
          `}
        >
          <NotFoundImage />
          <HeaderBlock heading={t('not-found.header', 'Well, this is unexpected...')} size="md" />
          <Body1>
            {t(
              'not-found.body',
              "We can help you search literally billions of records, but we can't seem to find the page you're looking for."
            )}
          </Body1>
          <Separator size="md" />
          <SubheaderBlock size="sm" heading={t('not-found.whats-next', "What's Next")} />
          <Separator size="xxs" />
          <Button
            emphasis="medium"
            onClick={() => {
              typeof window !== 'undefined' && window.location.reload()
            }}
          >
            {t('not-found.option-reload', 'Reload the page')}
          </Button>
          <Separator size="sm" />
          <Link external to="/help/helpcenter/">
            {t('not-found.option-help-center', 'Visit the Help Center')}
          </Link>
          <Separator size="xs" />
          <Link external to="/search/">
            {t('not-found.option-records', 'Find historical records')}
          </Link>
          <Separator size="xs" />
          <Link external to="/site-map">
            {t('not-found.option-site-map', 'View the site map')}
          </Link>
          <Separator size="xxs" />
          <Body2>{t('not-found.option-other', 'Or choose a new activity from the main site menu.')}</Body2>
        </div>
      </LayoutBand>
    </>
  )
}
